import { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../api";
export const useGetStripeVerficationStatus = (verficationID) => {
  const [stripeStatusCode, setStripeStatusCode] = useState("");
  const [stripeStatusResponse, setStripeStatusResponse] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = sessionStorage.getItem("AccessToken");
  const isVerify =  JSON.parse(localStorage.getItem("isVerify"))
  useEffect(() => {
    const getStripeLinkToverify = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${BASE_URL}licensedetail/getVerificationStatus/` +
          verficationID,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response?.status === 200) {
          const verificationStatus = response?.data?.data?.verificationStatus;
          setStripeStatusCode(verificationStatus);

          const verificationsResponse=response?.data?.data?.verificationResponse;
          setStripeStatusResponse(verificationsResponse);

          localStorage.removeItem("verificationSessionId");
          localStorage.removeItem("isVerify");

          setLoading(false);
        }
      } catch (error) {
        setError("Error fetching verification status:", error);
        setLoading(false);
      }
    };
    if(isVerify && verficationID){
        getStripeLinkToverify();
    }
  }, [token, verficationID, isVerify]);

  return { stripeStatusCode, setStripeStatusCode, loading, error,stripeStatusResponse };
};

export default useGetStripeVerficationStatus;
